import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`DDDTW 社群志工，同時也是社群講師。有多年軟體開發經驗，喜歡研究各種 Open Source 工具並將其帶入工作當中增加效率。目前在 XRSpace 擔任 Dept. Lead。相信聰明的懶惰是工程師最重要的特性。`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      